import { render, staticRenderFns } from "./HomepageDashboard.vue?vue&type=template&id=4b6d6050&scoped=true"
import script from "./HomepageDashboard.vue?vue&type=script&lang=js"
export * from "./HomepageDashboard.vue?vue&type=script&lang=js"
import style0 from "./HomepageDashboard.vue?vue&type=style&index=0&id=4b6d6050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d6050",
  null
  
)

export default component.exports